import React, { useEffect, useState } from 'react';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from 'react-icons/fi';
import Slider from 'react-slick';
import { getInvestorRelationsPage } from '../../../util/api.service';
import { slickDot } from '../../../page-demo/script';
import { getImageUrl } from '../../../util/util.service';
import { FormattedDate } from 'react-intl';
import Markdown from 'markdown-to-jsx/dist/index';
import { Link, useHistory } from 'react-router-dom';
import Footer from '../../common/footer/footer.component';
import PageHelmet from '../../common/page-helmet/page-helmet.component';
import Breadcrumb from '../../common/breadcrumb/breadcrumb.component';
import Skeleton from 'react-loading-skeleton';
import Header from '../../common/header/header.component';
import LazyImage
  from '../../../util/lazyloaders/lazy-image/lazy-image.component';
import ContactSection
  from '../../elements/contact-section/contact-section.component';

const InvestorRelations = () => {
  const [investorRelations, setInvestorRelations] = useState(null);
  const history = useHistory();

  useEffect(() => {
    getInvestorRelationsPage(history).then(({ attributes }) => setInvestorRelations(attributes));
  }, []);

  return (
    <>
      <PageHelmet pageTitle='Investor Relations' />
      <Header/>
      <Breadcrumb title='Investor Relations'
                  subTitle='&nbsp;'
      />

      {/* Start Portfolio Details */}
      <div className="rn-blog-details ptb--120 bg_color--1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="portfolio-details">
                <div className="inner">
                  <h2>{investorRelations?.title || <Skeleton count={2}/>}</h2>

                  <p className="subtitle">
                    {investorRelations?.subTitle ? investorRelations?.subTitle : investorRelations?.subTitle === null ? '' : <Skeleton count={2} />}
                  </p>

                  { investorRelations?.coverImage?.data &&
                    <LazyImage
                      placeholderWidth={500}
                      placeholderHeight={500}
                      image={investorRelations?.coverImage}
                      size="medium"
                      alt="Investor Relations"
                    />
                  }

                  {/* <div className="portfolio-view-list d-flex flex-wrap">
                    <div className="port-view">
                      <span>Location</span>
                      <h4>{pressRelease?.location || <Skeleton/>}</h4>
                    </div>

                    <div className="port-view">
                      <span>Start</span>
                      <h4>{pressRelease?.startAt &&
                        <FormattedDate value={pressRelease.startAt}/> ||
                        <Skeleton/>}</h4>
                    </div>

                    <div className="port-view">
                      <span>Type</span>
                      <h4>{pressRelease?.type || <Skeleton/>}</h4>
                    </div>
                  </div> */}

                  {/*<div className="portfolio-share-link mt--20 pb--70 pb_sm--40">
                    <ul className="social-share rn-lg-size d-flex justify-content-start liststyle mt--15">
                      {SocialShare.map((val, i) => (
                        <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                      ))}
                    </ul>
                  </div>*/}

                  <div className="investorRelations-description">
                    {investorRelations?.description ? <Markdown>{investorRelations.description}</Markdown> :
                      <p><Skeleton width="100%" count={9}/></p>}
                  </div>
                </div>
                {/*<div className="portfolio-thumb-inner">
                  <div className="thumb position-relative mb--30">
                    <img src="/assets/images/portfolio/portfolio-big-03.jpg" alt="Portfolio Images"/>
                    <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='ZOoVOfieAF8' onClose={() => this.setState({isOpen: false})} />
                    <button className="video-popup position-top-center" onClick={this.openModal}><span className="play-icon"></span></button>
                  </div>

                  <div className="thumb mb--30">
                    <img src="/assets/images/portfolio/portfolio-big-02.jpg"
                         alt="Portfolio Images"/>
                  </div>

                  <div className="thumb">
                    <img src="/assets/images/portfolio/portfolio-big-01.jpg"
                         alt="Portfolio Images"/>
                  </div>
                </div>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Portfolio Details */}

      {/* Start Related Work */}
      {/*<div className="portfolio-related-work pb--120 bg_color--1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center">
                <span className="theme-color font--18 fontWeight600">Expanding horizons</span>
                <h2>More opportunities</h2>
              </div>
            </div>
          </div>
          <div className="row mt--10">
             Start Single Portfolio
            <div className="col-lg-6 col-md-6 col-12">
              <div className="related-work text-center mt--30">
                <div className="thumb">
                  <a href="/portfolio-details">
                    <img src="/assets/images/portfolio/related-image-01.jpg"
                         alt="Portfolio-images"/>
                  </a>
                </div>
                <div className="inner">
                  <h4><a href="/portfolio-details">Digital Analysis</a></h4>
                  <span className="category">Technique</span>
                </div>
              </div>
            </div>
             End Single Portfolio
             Start Single Portfolio
            <div className="col-lg-6 col-md-6 col-12">
              <div className="related-work text-center mt--30">
                <div className="thumb">
                  <a href="/portfolio-details">
                    <img src="/assets/images/portfolio/related-image-02.jpg"
                         alt="Portfolio-images"/>
                  </a>
                </div>
                <div className="inner">
                  <h4><a href="/portfolio-details">Plan Management</a></h4>
                  <span className="category">PLANNING</span>
                </div>
              </div>
            </div>
             End Single Portfolio
          </div>
        </div>
      </div>*/}
      {/* End Related Work */}

      {/* Start Contact Page Area  */}
      <div className="container">
        <hr />
        <div className="row">
          <div className="col-lg-12">
            <h2 
              className='title text-center'
              style={{
                display: 'block',
                marginBottom: '28px',
                paddingBottom: '43px',
                borderBottom: '1px solid #e1e1e1',
              }}
            >JOIN THE REVOLUTION</h2>
          </div>
        </div>
      </div>
      <div className="rn-contact-page ptb--120 bg_color--1">
        <ContactSection title={investorRelations?.contactFormTitle} description={investorRelations?.contactFormSubtitle} image={investorRelations?.formImage}/>
      </div>
      {/* End Contact Page Area  */}

      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp/>
        </ScrollToTop>
      </div>
      {/* End Back To Top */}

      <Footer/>
    </>
  );
};

export default InvestorRelations;